import Service from '@/services/modules/leads.service';

const add = async({ commit }, _object) => {
    const response = Service.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const share = async({commit}, _object) => {
    const response = Service.share(_object);

    return response;
};

const all = async ({ commit }, _itens) => {
    const response = Service.all(_itens.limit, _itens.currentPage, _itens.params);

    response.then(function (_response) {
        if (_response.data !== undefined) {
            commit('setList', _response.data);
        } else {
            commit('setList', _response);
        }
    });

    return response;
};

 
const search = async ({ commit }, _params) => {
    const response = Service.search(_params);

    response.then(function (_response) {
        commit('setList', _response);
    });

    return response;
};


const histories = async ({ commit }, _module) => {
    const response = Service.getHistories(_module.id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};

const edit = async({ commit }, _module) => {
    const response = Service.edit(_module.id, _module);

    return response;
};

const get = async ({ commit }, _id) => {
    const response = Service.get(_id);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};


const rem = async({ commit }, _module) => {
    const response = Service.rem(_module.id);

    return response;
};

export default {
    add,
    all,
    edit,
    get,
    rem,
    histories,
    search,
    share
};
